var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"wh-logo"},[_c('div',{staticClass:"mask"},[_c('div',{staticClass:"wipe"})])]),_c('h2',{staticClass:"sub-title"},[_vm._v("Interactive Map")])])}]

export { render, staticRenderFns }